import { Component, OnDestroy, OnInit } from '@angular/core';
import { Project } from '../shared/interfaces/project.interface';
import { ProjectGroup } from '../shared/interfaces/project-group.interface';
import { ProjectRouteStation } from '../shared/interfaces/project-route-station.interface';
import { Subscription } from 'rxjs';
import { ProjectDataService } from '../shared/services/project-data.service';
import { ProjectService } from '../shared/services/project.service';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageDataService } from '../shared/services/image-data.service';
import { ProjectImageData } from '../shared/interfaces/project-image-data.interface';
import { AddScenarioDialogComponent } from './add-scenario-dialog/add-scenario-dialog.component';
import { ScenarioService } from '../shared/services/scenario.service';
import { Scenario } from '../shared/interfaces/scenario.interface';
import { GroupService } from '../shared/services/group.service';
import { SchemaLine, SchemaLineWithPosition } from '../project-schema/shared/interfaces/schema-line.class';
import { ProjectRouteStationWithParam } from '../shared/interfaces/project-route-station.class';
import { ScenarioManual } from '../shared/interfaces/scenario-manual';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { EditUser } from 'src/app/user/shared/interfaces/edit-user.interface';
import { MetaInformationService } from '../shared/services/meta-information.service';
import { ProjectGroupMetaInformation } from '../shared/interfaces/project-group-meta-information';
import { getMetaInformationLabel } from '../shared/functions/meta-information-label';

@Component({
  selector: 'avs-project-scenario',
  templateUrl: './project-scenario.component.html',
  styleUrls: ['./project-scenario.component.css']
})
export class ProjectScenarioComponent implements OnInit, OnDestroy {
  public activeProject: Project | undefined;
  public activeGroup: ProjectGroup | undefined;
  public routeStations: ProjectRouteStation[] = [];
  public routeStationsY1: ProjectRouteStation[] = [];
  public routeStationsY2: ProjectRouteStation[] = [];
  public projectRouteStations: ProjectRouteStationWithParam[] | undefined;
  public subscriptionCollection: Subscription[] = [];
  public activeProjectSubscription?: Subscription;
  public activeGroupSubscription?: Subscription;
  public routeStationsSubscription?: Subscription;
  public projectImagesSubscription?: Subscription;
  public activeProjectsUsers: EditUser[] = [];
  public projectRouteStationsWithParamSubscription?: Subscription;
  public images: ProjectImageData[] = [];
  public allImages: ProjectImageData[] = [];
  public scenarios: Scenario[] = [];
  public unassignedStations: ProjectRouteStationWithParam[] = [];
  public metaInformation: ProjectGroupMetaInformation[] = [];
  private activeProjectsUsersSubscription?: Subscription;

  public NbPositions: number = 25; 
  public width: number[] = new Array(this.NbPositions).fill(50);

  public line: SchemaLine = new SchemaLine(
   [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] }, 
    { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 25, isActive: false, line: [], colorArr: [] }
  ],

    [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
    { station: undefined, x: 25, isActive: false, line: [], colorArr: [] }
  ]);

 
  constructor(
    private projectDataService: ProjectDataService,
    private projectService: ProjectService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private imageDataService: ImageDataService,
    private scenarioService: ScenarioService,
    private groupService: GroupService,
    private metaInfoService: MetaInformationService
  ) {

    
    this.activeProjectSubscription = this.projectDataService.activeProject.subscribe((project) => {
      this.activeProject = project;
    });
    this.activeGroupSubscription = this.projectDataService.activeGroup.subscribe((group) => {
      if (group !== this.activeGroup)
        this.activeGroup = group;
      this.getGroupsScenarios();
      if (this.activeGroup !== undefined) {
        this.getGroupsScenarios();
        this.loadMetaInformation(this.activeGroup.id);
      }
    });
    this.activeProjectsUsersSubscription = projectDataService.activeProjectsUsers.subscribe(users => {
      this.activeProjectsUsers = users;
    })
    this.routeStationsSubscription = projectDataService.projectsRouteStations.subscribe(routeStations => {
      this.routeStations = routeStations;
      this.sortRouteStationsByY(routeStations)
    });
    this.projectImagesSubscription = imageDataService.projectImages.subscribe(images => {
      this.images = images;
      this.allImages = images;
      if (images) { this.rotateImagesPaths(images) }
    });
    this.projectRouteStationsWithParamSubscription = projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      this.projectRouteStations = routeStations;
      this.sortRouteStationsIntoLine();
    });
  }

  public ngOnInit(): void {
    this.subscriptionCollection.push(this.activeProjectSubscription!);
    this.subscriptionCollection.push(this.activeGroupSubscription!);
    this.subscriptionCollection.push(this.routeStationsSubscription!);
    this.subscriptionCollection.push(this.projectImagesSubscription!);
    this.subscriptionCollection.push(this.projectRouteStationsWithParamSubscription!);
    this.subscriptionCollection.push(this.activeProjectsUsersSubscription!);
  }

  public rotateImagesPaths(images: ProjectImageData[]): void {
    images.forEach(image => {
      if (image.isAnimated && image.animatedImageIds!.length > 0) { /* für jedes Bild, das für die RouteStation gesetzt wird, wird nun separat geprüft ob ein animatedImageId vorhanden ist */
        this.rotatePathForId(image)
      }
    });
  }

  public rotatePathForId(image: ProjectImageData): void {
    const myValueList = image.animatedImageIds!;
    let i = 0;
    const id = setInterval(() => {
      image.path = this.getPathByImageId(myValueList[i++]); /* iteration durchs animatedimage array, und zieht sich dasnn über die id, den path */
      if (i === myValueList.length) {
        i = 0;
      }
    }, 1000);
  }

  public getPathByImageId(imageId: number) {
    if (this.allImages) {
      let imageObject = this.allImages.find((x) => x.imageId == imageId)
      return imageObject?.path as string
    }
    else return
  }
  public ngOnDestroy(): void {
    this.subscriptionCollection.forEach(sub => sub.unsubscribe());
  }

  private loadMetaInformation(groupId: number): void {
    this.metaInfoService.getMetaInformationByGroupId(groupId).subscribe((metaInfo: ProjectGroupMetaInformation[]) => {
      this.metaInformation = metaInfo ?? [];
    });
  }

  public getPositionLabel(x: number, y: number): string {
    return getMetaInformationLabel(this.metaInformation, x, y);
  }

  savedPosition: number = 0;
  public handleEvent(event: boolean) {
    if (event) {
      this.getGroupsScenarios(true)
    }
  }
  public sortRouteStationsByY(routeStations: ProjectRouteStation[]): void {
    this.routeStationsY1 = [];
    this.routeStationsY2 = [];
    routeStations.forEach((station) => {
      if (station.y === 1) {
        this.routeStationsY1.push(station);
      }
      if (station.y === 2) {
        this.routeStationsY2.push(station);
      }
    });
  }

  public sortRouteStationsIntoLine(): void {
    this.line = new SchemaLine(
      [{ station: undefined, x: 1, isActive: this.line.areaA[0].isActive, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: this.line.areaA[1].isActive, line: [], colorArr: [] },
      { station: undefined, x: 3, isActive: this.line.areaA[2].isActive, line: [], colorArr: [] }, { station: undefined, x: 4, isActive: this.line.areaA[3].isActive, line: [], colorArr: [] },
      { station: undefined, x: 5, isActive: this.line.areaA[4].isActive, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: this.line.areaA[5].isActive, line: [], colorArr: [] },
      { station: undefined, x: 7, isActive: this.line.areaA[6].isActive, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: this.line.areaA[7].isActive, line: [], colorArr: [] },
      { station: undefined, x: 9, isActive: this.line.areaA[8].isActive, line: [], colorArr: [] }, { station: undefined, x: 10, isActive: this.line.areaA[9].isActive, line: [], colorArr: [] },
      { station: undefined, x: 11, isActive: this.line.areaA[10].isActive, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: this.line.areaA[11].isActive, line: [], colorArr: [] },
      { station: undefined, x: 13, isActive: this.line.areaA[12].isActive, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: this.line.areaA[13].isActive, line: [], colorArr: [] },
      { station: undefined, x: 15, isActive: this.line.areaA[14].isActive, line: [], colorArr: [] }, { station: undefined, x: 16, isActive: this.line.areaA[15].isActive, line: [], colorArr: [] },
      { station: undefined, x: 17, isActive: this.line.areaA[16].isActive, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: this.line.areaA[17].isActive, line: [], colorArr: [] },
      { station: undefined, x: 19, isActive: this.line.areaA[18].isActive, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: this.line.areaA[19].isActive, line: [], colorArr: [] },
      { station: undefined, x: 21, isActive: this.line.areaA[20].isActive, line: [], colorArr: [] }, { station: undefined, x: 22, isActive: this.line.areaA[21].isActive, line: [], colorArr: [] },
      { station: undefined, x: 23, isActive: this.line.areaA[22].isActive, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: this.line.areaA[23].isActive, line: [], colorArr: [] },
      { station: undefined, x: 25, isActive: this.line.areaA[24].isActive, line: [], colorArr: [] }
    ],
      [{ station: undefined, x: 1, isActive: this.line.areaB[0].isActive, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: this.line.areaB[1].isActive, line: [], colorArr: [] },
      { station: undefined, x: 3, isActive: this.line.areaB[2].isActive, line: [], colorArr: [] }, { station: undefined, x: 4, isActive: this.line.areaB[3].isActive, line: [], colorArr: [] },
      { station: undefined, x: 5, isActive: this.line.areaB[4].isActive, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: this.line.areaB[5].isActive, line: [], colorArr: [] },
      { station: undefined, x: 7, isActive: this.line.areaB[6].isActive, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: this.line.areaB[7].isActive, line: [], colorArr: [] },
      { station: undefined, x: 9, isActive: this.line.areaB[8].isActive, line: [], colorArr: [] }, { station: undefined, x: 10, isActive: this.line.areaB[9].isActive, line: [], colorArr: [] },
      { station: undefined, x: 11, isActive: this.line.areaB[10].isActive, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: this.line.areaB[11].isActive, line: [], colorArr: [] },
      { station: undefined, x: 13, isActive: this.line.areaB[12].isActive, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: this.line.areaB[13].isActive, line: [], colorArr: [] },
      { station: undefined, x: 15, isActive: this.line.areaB[14].isActive, line: [], colorArr: [] }, { station: undefined, x: 16, isActive: this.line.areaB[15].isActive, line: [], colorArr: [] },
      { station: undefined, x: 17, isActive: this.line.areaB[16].isActive, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: this.line.areaB[17].isActive, line: [], colorArr: [] },
      { station: undefined, x: 19, isActive: this.line.areaB[18].isActive, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: this.line.areaB[19].isActive, line: [], colorArr: [] },
      { station: undefined, x: 21, isActive: this.line.areaB[20].isActive, line: [], colorArr: [] }, { station: undefined, x: 22, isActive: this.line.areaB[21].isActive, line: [], colorArr: [] },
      { station: undefined, x: 23, isActive: this.line.areaB[22].isActive, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: this.line.areaB[23].isActive, line: [], colorArr: [] },
      { station: undefined, x: 25, isActive: this.line.areaB[24].isActive, line: [], colorArr: [] }]);

    let widthA: number[] = new Array(this.NbPositions).fill(150);
    let widthB: number[] = new Array(this.NbPositions).fill(150);

    if (this.projectRouteStations === undefined) return;
    for (let station of this.projectRouteStations!) {
      if (station.routeStation.y === 1) {
        if (station.routeStation.x > 0 && station.routeStation.x < this.line.areaA.length+1 && station.routeStation.x < widthA.length+1) {
          if (this.line.areaA[station.routeStation.x - 1].station) {
            this.line.areaA[station.routeStation.x - 1].station?.push(station);
            this.line.areaA[station.routeStation.x - 1].isActive = true;
            widthA[station.routeStation.x - 1] += 300;
          } else {
            this.line.areaA[station.routeStation.x - 1].station = [station];
            this.line.areaA[station.routeStation.x - 1].isActive = true;
            widthA[station.routeStation.x - 1] = 300;
          }
        } else {
          this.unassignedStations.push(station);
        }
      } else if (station.routeStation.y === 2) {
        if (station.routeStation.x > 0 && station.routeStation.x < this.line.areaB.length+1 && station.routeStation.x < widthB.length+1) {
          if (this.line.areaB[station.routeStation.x - 1].station) {
            this.line.areaB[station.routeStation.x - 1].station?.push(station);
            this.line.areaB[station.routeStation.x - 1].isActive = true;
            widthB[station.routeStation.x - 1] += 300;
          } else {
            this.line.areaB[station.routeStation.x - 1].station = [station];
            this.line.areaB[station.routeStation.x - 1].isActive = true;
            widthB[station.routeStation.x - 1] = 300;
          }
        } else {
          this.unassignedStations.push(station);
        }
      } else {
        this.unassignedStations.push(station);
      }
    }

    for (let index = 0; index < this.width.length && index < widthA.length && index < widthB.length; index++) {
      this.width[index] = widthA[index] > widthB[index] ? widthA[index] : widthB[index];
    }
    this.getHighestXAndCollapse()
  }

  public getHighestXAndCollapse() {
    let highestX = 0;
    this.routeStations.forEach((station) => {
      if (station.x > highestX) {
        highestX = station.x;
      }
    });

    for (let index = highestX; index < this.line.areaA.length; index++) {
      this.line.areaA[index].isHidden = true;
    }
    for (let index = highestX; index < this.line.areaB.length; index++) {
      this.line.areaB[index].isHidden = true;
    }
  }

  public getGroupsScenarios(restoreScroll: boolean = false): void {
    const scrollPosition = restoreScroll ? this.getScenarioScrollPosition() : undefined;
    this.scenarios = [];
    if (this.activeGroup === undefined) return;
    this.scenarioService.getAllScenariosByGroupId(this.activeGroup?.id as number).subscribe((scenarios) => {
      this.scenarios = scenarios;
      if (scrollPosition) {
        this.restoreScenarioScrollPosition(scrollPosition);
      }
    });
  }

  private getScenarioScrollPosition(): { containerTop: number, windowTop: number, windowLeft: number } {
    const container = document.getElementById('scrollBody');
    return {
      containerTop: container ? container.scrollTop : 0,
      windowTop: window.scrollY,
      windowLeft: window.scrollX
    };
  }

  private restoreScenarioScrollPosition(position: { containerTop: number, windowTop: number, windowLeft: number }): void {
    setTimeout(() => {
      const container = document.getElementById('scrollBody');
      if (container) {
        container.scrollTop = position.containerTop;
      }
      window.scrollTo(position.windowLeft, position.windowTop);
    });
  }

  public onEditScenarioBtnClicked(scenario: Scenario) {
    const dialogRef = this.dialog.open(AddScenarioDialogComponent, { data: { group: this.activeGroup, scenario: scenario } });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.scenarioService.updateScenario(scenario.id as number, { name: result.name, enabled: result.enabled, groupId: this.activeGroup?.id as number }).subscribe((scenario) => {
          this.getGroupsScenarios(true);
        });
      }
    });
  }

  public onDeleteScenarioBtnClicked(scenario: Scenario) {
    this.scenarioService.deleteScenario(scenario.id as number).subscribe(() => {
      this.getGroupsScenarios(true);
    });
  }

  public onStopScenarioBtnClicked(scenario: Scenario) {
    this.scenarioService.disableScenario(scenario.id as number).subscribe(() => {
      this.alertService.alert('Szenario deaktiviert', AlertTypes.success);
      this.getGroupsScenarios(true);
    });
  }

  public onPlayScenarioBtnClicked(scenario: Scenario) {
    this.scenarioService.enableScenario(scenario.id as number).subscribe(() => {
      this.alertService.alert('Szenario aktiviert', AlertTypes.success);
      this.getGroupsScenarios(true);
    });
  }

  public getScenarioManualByScenarioID(scenario: Scenario) {
    let manuals = this.scenarios.find((x) => x.id === scenario.id)?.scenarioManuals;
    return manuals;
  }

  public onExpandScenarioClicked(): void {
    for (let area of this.line.areaA) {
      area.isActive = true;
    }
    for (let area of this.line.areaB) {
      area.isActive = true;
    }
  }

  public onUpdateScenario(scenario: Scenario): void {
    const scenarioExists = this.scenarios.some((x) => x.id === scenario.id);
    this.scenarios = scenarioExists
      ? this.scenarios.map((x) => x.id === scenario.id ? scenario : x)
      : [...this.scenarios, scenario];
  }

  public onCollapseSchemeClicked(): void {
    if (!this.projectRouteStations) {
      return;
    }
    if (this.projectRouteStations.length === 0) {
      for (let area of this.line.areaA) {
        area.isActive = false;
      }
      for (let area of this.line.areaB) {
        area.isActive = false;
      }
      return;
    }
    let stationsA: ProjectRouteStationWithParam[] = [];
    let stationsB: ProjectRouteStationWithParam[] = [];
    for (let station of this.projectRouteStations) {
      if (station.routeStation.y === 1) {
        stationsA.push(station);
      } else if (station.routeStation.y === 2) {
        stationsB.push(station);
      }
    }
    let stations = this.projectRouteStations.sort(
      (a, b) => b.routeStation.x - a.routeStation.x);
    for (let area of this.line.areaA) {
      if (stationsA[0]) {
        if (area.x > stations[0].routeStation.x) {
          area.isActive = false;
        }
      } else {
        area.isActive = false;
      }
    }
    for (let area of this.line.areaB) {
      if (stationsB[0]) {
        if (area.x > stations[0].routeStation.x) {
          area.isActive = false;
        }
      } else {
        area.isActive = false;
      }
    }
  }

  public onCreateScenarioBtnClicked(): void {
    const dialogRef = this.dialog.open(AddScenarioDialogComponent, { data: { group: this.activeGroup } });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.scenarioService.createScenario({ name: result.name, enabled: result.enabled, groupId: this.activeGroup?.id as number }).subscribe((scenario) => {
          this.getGroupsScenarios();
        });
      }
    });
  }
}
